import {Drawer} from 'primeng/drawer';

/**
 * Correzioni a bug di PrimeNG, applicate una sola volta al bootstrap (v. main.ts).
 * Da ricontrollare (ed eventualmente togliere) a ogni aggiornamento di PrimeNG.
 */
export function applicaPatchPrimeNg(): void {
	patchDrawerEscape();
}

/**
 * PrimeNG 21.1.9 - p-drawer: con il focus dentro il drawer, il (keydown) del contenitore su ESC chiama hide() SENZA
 * controllare closeOnEscape: il drawer resta aperto ma la maschera scura sparisce (e lo scroll del body si sblocca).
 * Qui ESC viene ignorato se closeOnEscape = false; con closeOnEscape = true il comportamento resta quello originale.
 */
function patchDrawerEscape(): void {
	const onKeyDownOriginale = Drawer.prototype.onKeyDown;
	Drawer.prototype.onKeyDown = function (this: Drawer, event: KeyboardEvent) {
		if (event.code === 'Escape' && !this.closeOnEscape) {
			return;
		}
		onKeyDownOriginale.call(this, event);
	};
}
